import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { deleteProject, disableProject, enableProject } from '../../query';
import Loading from '../../../../../components/Loading';
import ConfirmationModal from '../../../../../components/Modals/ConfirmationModal';

class Action extends Component {
    constructor(props) {
        super();
        this.onDelete = this.onDelete.bind(this);
        this.onCloseDeleteModal = this.onCloseDeleteModal.bind(this);
        this.onDisableKeyword = this.onDisableKeyword.bind(this);

        this.state = {
            name: props.item.name,
            own_domain: props.item.own_domain ?? '',
            own_product: props.item.own_product_name ?? '',
            loading: false,
            isOpendeleteModal: false,
            competitors: props.item.competitors || [],
            error: {},
            status: !props.is_disabled,
        };
    }

    onCloseDeleteModal() {
        this.setState({
            isOpendeleteModal: false,
        });
    }

    async onDelete() {
        try {
            this.setState({
                deleteLoading: true,
            });
            this.onCloseDeleteModal();

            await deleteProject(this.props.item.id);
            this.setState({
                deleteLoading: false,
            });
            this.props.updateData('delete', this.props.item.id);
        } catch (err) {
            this.setState({
                deleteLoading: false,
            });
        }
    }

    async onDisableKeyword() {
        try {
            this.setState({ loading: true });

            if (this.state.status) {
                await disableProject(this.props.item.id);
            } else {
                await enableProject(this.props.item.id);
            }
            this.setState({
                status: !this.state.status,
                loading: false,
            });
            this.props.updateData('update', this.props.item.id, {
                is_disabled: !this.state.status,
            });
            // this.props.getKeywords();
        } catch (err) {
            this.setState({
                loading: false,
            });
            console.log(err);
        }
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="d-flex gap-8">
                    <a
                        href={`/ai-tracking/project/${this.props.item.id}/settings/`}
                        className="table-action-main-btn"
                        title={t('ai_tracking.projects.settings.header')}
                    >
                        <i className="icon-settings1"></i>
                    </a>
                    <a
                        href={`/ai-tracking/prompt-generator?projectId=${this.props.item.id}`}
                        className="table-action-main-btn"
                    >
                        {t('ai_tracking.prompt_generator.generate_prompts')}
                    </a>
                    {!this.props.is_default &&
                        (this.state.loading ? (
                            <div className="px-5 d-flex align-items-center">
                                <Loading onlyPreloader />
                            </div>
                        ) : (
                            <button
                                className="ignor-icon-btn ai_tracking_switcher"
                                onClick={this.onDisableKeyword}
                                title={
                                    this.state.status
                                        ? t(
                                              'ai_tracking.keyword_manager.edit_keyword.disable_title',
                                          )
                                        : t('ai_tracking.keyword_manager.edit_keyword.enable_title')
                                }
                            >
                                <span
                                    className={`switch-button ${
                                        this.state.status ? 'active' : 'not-active'
                                    }`}
                                >
                                    <span className="switch-circle" />
                                </span>
                            </button>
                        ))}
                </div>
                {/* <ConfirmationModal
                    isOpen={this.state.isOpendeleteModal}
                    onClose={this.onCloseDeleteModal}
                    buttonName={t('ai_tracking.projects.edit.yes')}
                    cancleBtn={t('ai_tracking.projects.edit.no')}
                    onSubmit={this.onDelete}
                    message={t('ai_tracking.projects.edit.confirmation_message')}
                /> */}
            </>
        );
    }
}

export default withTranslation()(Action);
